const NICKNAME_STORAGE_PREFIX = "zsombzilla.publicNickname.";

const GUEST_NAMES = [
  "Tökfőzelék",
  "Kakaóscsiga",
  "Palacsintazilla",
  "Uborkahős",
  "Zoknizilla",
  "Rántottsajt",
  "Pudingóriás",
  "Mákosguba",
  "Nokedlikapitány",
  "Lekvárszörny",
] as const;

function storageKey(uid: string): string {
  return `${NICKNAME_STORAGE_PREFIX}${uid}`;
}

function stableHash(value: string): number {
  let hash = 2166136261;
  for (const character of value) {
    hash ^= character.codePointAt(0) ?? 0;
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

export function getStoredPublicNickname(uid: string): string | null {
  try {
    return window.localStorage.getItem(storageKey(uid));
  } catch {
    return null;
  }
}

export function storePublicNickname(uid: string, nickname: string): void {
  try {
    window.localStorage.setItem(storageKey(uid), nickname);
  } catch {
    // Firestore becomes the durable source in step 5; auth must still work without local storage.
  }
}

export function getOrCreateGuestNickname(uid: string): string {
  const stored = getStoredPublicNickname(uid);
  if (stored) {
    return stored;
  }

  const hash = stableHash(uid);
  const name = GUEST_NAMES[hash % GUEST_NAMES.length];
  const number = 100 + (Math.floor(hash / GUEST_NAMES.length) % 900);
  const nickname = `${name} #${number}`;
  storePublicNickname(uid, nickname);
  return nickname;
}

export function validatePublicNickname(value: string):
  | { ok: true; nickname: string }
  | { ok: false; message: string } {
  const nickname = value.trim().replace(/\s+/g, " ");
  const length = Array.from(nickname).length;

  if (length < 3 || length > 20) {
    return { ok: false, message: "A becenév 3-20 karakter hosszú legyen." };
  }
  if (/[\u0000-\u001f\u007f]/u.test(nickname)) {
    return { ok: false, message: "A becenév nem tartalmazhat vezérlőkaraktert." };
  }

  return { ok: true, nickname };
}
